<template>
  <div>
    <div v-if="clientReference">
      <v-select
        :disabled="!isStaff"
        :items="invoicesForClient"
        label="Select Invoice To Add To"
        v-model="selectedInvoice"
        @change="getSelectedInvoice"
      ></v-select>
    </div>
  </div>
</template>
<script>
import clientsJs from "@/plugins/clients";
import invoicesAndQuotesJs from "@/plugins/invoicesAndQuotes";

export default {
  props: { clientReference: { default: null } },
  computed: {
    isStaff() {
      return this.$store.getters.isStaff;
    },
  },
  data: () => ({
    invoicesForClient: [],
    selectedInvoice: null,
    newInvoice: {
      id: null,
    },
  }),
  watch: {
    async clientReference(newVal) {
      await this.getClientInvoices(newVal);
    },
  },
  async mounted() {
    if (this.clientReference) {
      await this.getClientInvoices(this.clientReference);
    }
  },
  methods: {
    async getClientInvoices(clientReference) {
      this.$store.commit("setLoader", true);
      const invoices = await clientsJs.getClientInvoices(clientReference);
      this.$store.commit("setLoader", false);
      if (invoices.length > 0) {
        this.invoicesForClient = [];
        invoices.forEach((invoice) => {
          this.invoicesForClient.push({
            ...invoice,
            text: `Inv#: ${invoice.invoice_number} | Due: ${invoice.due}`,
            value: invoice,
          });
        });
      }
      this.invoicesForClient.unshift({
        text: "Create New Invoice",
        value: "new",
      });
    },
    getSelectedInvoice(selectedInvoice) {
      if (selectedInvoice == "new") {
        this.$emit("get-selected-invoice", this.newInvoice);
      } else {
        this.$emit("get-selected-invoice", selectedInvoice);
      }
    },
  },
};
</script>
